import styled from '@emotion/styled';
import { Colors } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';

export const SmallGrayText = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: ${Colors.grey700};
`;

export const SmallBlueText = styled.p`
  line-height: 20px;
  font-size: 14px;
  font-weight: 600;
`;

export const MediumGrayText = styled.p`
  font-size: 16px;
  line-height: 150%;
  color: ${Colors.grey700};
  ${mediaQueries.tablet} {
    font-size: 20px;
    line-height: 140%;
  }
`;

export const LargeBlackText = styled.h1`
  font-size: 28px;
  line-height: 120%;
  ${mediaQueries.tablet} {
    font-size: 48px;
  }
`;
